export default {
    SELECT_NODES_FOR_ADDING_TO_SUMMARY_REPORT: "Пожалуйста, выберите узлы для добавления в сводку",
    ERROR_WHILE_APPLYING_LAYOUT: "Не удалось применить выбранную форму графа. Граф слишком большой",
    OBJECTS: "Объекты"
};
